/**
 * Zustand Store Configuration
 * Central state management for client-side state
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

// Import store slices
import { createAuthSlice } from './slices/authSlice';
import { createDeviceSlice } from './slices/deviceSlice';
import { createMapSlice } from './slices/mapSlice';
import { createUISlice } from './slices/uiSlice';

/**
 * Main application store
 * Combines all slices into a single store
 */
export const useStore = create(
  devtools(
    (...args) => ({
      ...createAuthSlice(...args),
      ...createDeviceSlice(...args),
      ...createMapSlice(...args),
      ...createUISlice(...args),
    }),
    { name: 'SR-UI-Store' }
  )
);






